import React from "react";
import ReactApexChart from "react-apexcharts";

interface VoteData {
    options: string;
    amount: number;
}

interface Props {
    votesCount: VoteData[];
}

const VotesCountPieChart: React.FC<Props> = ({ votesCount }) => {
    const options = {
        chart: {
            type: "pie" as const,
        },
        legend: {
            show: true,
            position: "bottom" as const,
        },
        labels: votesCount.map((vote) => vote.options),
        colors: ["#D549CD", "#2A4971", "#5DC6FF", "#7C9EFF", "#E43E9F"],
    };

    const series = votesCount.map((vote) => vote.amount);

    return (
        <div>
            <ReactApexChart
                options={options}
                series={series}
                type="pie"
                height={350}
            />
        </div>
    );
};

export default VotesCountPieChart;
